export function formatMutationErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (!error || typeof error !== 'object') return fallback;
  const e = error as {
    message?: string;
    response?: { data?: { message?: unknown } };
  };
  const raw = e.response?.data?.message;
  if (Array.isArray(raw)) return raw.join(' ');
  if (typeof raw === 'string') return raw;
  if (e.message) return e.message;
  return fallback;
}
